import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';

import Login from './login/Login';
import {ForgotPassword, ResetPassword} from './login/PasswordReset';
import Dashboard from './project.uni/Dashboard';
import ManageResources from './ManageResources/ManageResources';
import QuestionEngine from './QuestionEngine/QuestionEngine';
import ExamPlanner from './ExamPlanner/ExamPlanner';
import LlmLogs from './LlmLogs/LlmLogs';
import QuestionBank from './QuestionBank/QuestionBank';
import OrganizationAccess from './OrganizationAccess/OrganizationAccess';
import ExamPage from './ExamPage/ExamPage';
import ExamBuilder from './ExamPage/ExamBuilder';
import TeacherExamWorkspace from './ExamPage/TeacherExamWorkspace';
import ProfilePage from './ProfilePage/ProfilePage';
import HomePage from './HomePage/HomePage';
import LearningAgent from './LearningAgent/LearningAgent';
import InteractiveLearningAgent, {PracticePage} from './LearningAgent/InteractiveLearningAgent';
import TeacherAgentWorkspace from './TeacherAgent/TeacherAgentWorkspace';
import KnowledgeGraph from './KnowledgeGraph/KnowledgeGraph';
import KnowledgeConcepts from './KnowledgeGraph/KnowledgeConcepts';
import KnowledgeRunStatus from './KnowledgeGraph/KnowledgeRunStatus';

// ✅ Layout جدید (هدر + سایدبار + Outlet)
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PublicOnlyRoute from './components/auth/PublicOnlyRoute';
import RoleRoute from './components/auth/RoleRoute';
import SystemAdminRoute from './components/auth/SystemAdminRoute';
import LearnerStateAdminRoute from './components/auth/LearnerStateAdminRoute';
import AdminLearnerState from './AdminLearnerState/AdminLearnerState';
import CourseLearnerMonitor from './AdminLearnerState/CourseLearnerMonitor';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage/>}/>
                <Route element={<PublicOnlyRoute/>}>
                    <Route path="/login" element={<Login/>}/>
                </Route>
                <Route path="/forgot-password" element={<ForgotPassword/>}/>
                <Route path="/reset-password" element={<ResetPassword/>}/>

                {/* ✅ همه صفحات داخل پنل: با AppHeader + Sidebar */}
                <Route element={<ProtectedRoute/>}>
                    <Route element={<AppLayout/>}>
                        <Route element={<RoleRoute allowedRoles={['teacher']}/>}>
                            <Route path="/dashboard" element={<Dashboard/>}/>
                            <Route path="/manageresources" element={<ManageResources/>}/>
                            <Route path="/knowledge-graph" element={<Navigate to="/manageresources" replace/>}/>
                            <Route path="/knowledge-graph/concepts" element={<KnowledgeConcepts/>}/>
                            <Route path="/knowledge-graph/concepts/:conceptId" element={<KnowledgeConcepts/>}/>
                            <Route path="/knowledge-graph/runs/:runId" element={<KnowledgeRunStatus/>}/>
                            <Route path="/knowledge-graph/:resourceId" element={<KnowledgeGraph/>}/>
                            <Route path="/question-engine" element={<QuestionEngine/>}/>
                            <Route path="/questionBank" element={<QuestionBank/>}/>
                            <Route path="/organizations" element={<OrganizationAccess/>}/>
                            <Route path="/exampage/create" element={<ExamBuilder/>}/>
                            <Route path="/exampage/:examId/edit" element={<ExamBuilder/>}/>
                            <Route path="/exampage/:examId/manage" element={<TeacherExamWorkspace/>}/>
                        </Route>
                        <Route element={<SystemAdminRoute/>}>
                            <Route path="/teacher-agent" element={<TeacherAgentWorkspace/>}/>
                            <Route path="/teacher-agent/decisions/:decisionId" element={<TeacherAgentWorkspace/>}/>
                            <Route path="/teacher-agent/reviews" element={<TeacherAgentWorkspace/>}/>
                            <Route path="/teacher-agent/reviews/:decisionId" element={<TeacherAgentWorkspace/>}/>
                            <Route path="/teacher-agent/grading" element={<TeacherAgentWorkspace/>}/>
                            <Route path="/learning-agent" element={<InteractiveLearningAgent/>}/>
                            <Route path="/learning-agent/:conversationId" element={<InteractiveLearningAgent/>}/>
                            <Route path="/practice/:attemptId" element={<PracticePage/>}/>
                            <Route path="/exam-planner" element={<ExamPlanner/>}/>
                            <Route path="/learning-agent-legacy" element={<LearningAgent/>}/>
                            <Route path="/llm-logs" element={<LlmLogs/>}/>
                        </Route>
                        <Route element={<LearnerStateAdminRoute/>}>
                            <Route path="/learner-state" element={<AdminLearnerState/>}/>
                            <Route path="/learner-state/:learnerId" element={<AdminLearnerState/>}/>
                            <Route path="/learner-state/:learnerId/graphs/:graphId" element={<AdminLearnerState/>}/>
                            <Route path="/learner-state/:learnerId/resources/:resourceId" element={<AdminLearnerState/>}/>
                            <Route path="/course-learner-state/:courseId" element={<CourseLearnerMonitor/>}/>
                        </Route>
                        <Route path="/exampage" element={<ExamPage/>}/>
                        <Route element={<RoleRoute allowedRoles={['student']} />}>
                            <Route path="/exampage/results" element={<ExamPage/>}/>
                            <Route path="/exampage/requests" element={<ExamPage/>}/>
                        </Route>
                        <Route path="/profilepage" element={<ProfilePage/>}/>
                    </Route>
                </Route>

                {/* مسیرهای ناشناخته */}
                <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
            </Routes>
        </Router>
    );
}

export default App;
